import root from 'react-shadow'
import React, { useEffect, useRef, useState } from 'react'
import { useViewStore } from '../Contexts/ViewContext'
import { useRetorikStore } from '../Contexts/RetorikContext'

import * as tailwind from 'bundle-text:../../tailwind.css'
import * as leaflet from 'bundle-text:../../../node_modules/leaflet/dist/leaflet.css'
import { imageFiles } from '../../utils/imageFiles'

// These lines allow correct default icon display, either way they are searched by relative path and not found
import L from 'leaflet'
import { markerShadow } from '../../models/urlEncodedImages'

const DefaultIcon = L.icon({
  iconUrl: `${imageFiles.mapArrival}`,
  shadowUrl: markerShadow,
  iconSize: [32, 41],
  iconAnchor: [10, 41]
})
L.Marker.prototype.options.icon = DefaultIcon

const ShadowRoot = ({ children }): JSX.Element => {
  const visibility = useViewStore((state) => state.visibility)
  const customScripts = useRetorikStore((state) => state.customScripts)
  const customCSS = useRetorikStore((state) => state.customCSS)
  const [alreadyAppliedCustomScripts, setAlreadyAppliedCustomScripts] = useState<Array<string>>([])
  const shadowRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (shadowRef?.current) {
      customScripts.forEach((customScript) => {
        if (!alreadyAppliedCustomScripts.includes(customScript)) {
          // Add the URL of the script to the already processed ones to prevent duplicate injection
          setAlreadyAppliedCustomScripts((current) => [...current, customScript])
          // Create a script element and inject it in the shadowroot
          const scriptElement = document.createElement('script')
          scriptElement.type = 'text/javascript'
          scriptElement.src = customScript
          scriptElement.onload = () => {
            console.log(`Retorik Framework > custom script loaded from ${customScript}`)
          }
          shadowRef.current?.appendChild(scriptElement)
        }
      })
    }
  }, [customScripts])

  return (
    <root.div
      id='retorik-shadow'
      ref={shadowRef}
      className='rf-w-full rf-h-full'
      style={{
        position: 'relative',
        overscrollBehaviorY: 'contain',
        touchAction: 'pan-x pan-y',
        visibility: visibility as any
      }}
    >
      {children}
      <style type='text/css'>{`${tailwind}`}</style>
      <style type='text/css'>{`${leaflet}`}</style>
      {customCSS.map((css, key) => {
        return <link key={key} rel="stylesheet" href={css}></link>
      })}
    </root.div>
  )
}

export default ShadowRoot
